import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.removeItem("dgl_token");
    // Returning from Emergent Google auth: AuthCallback exchanges the session_id first, skip /me here
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  /* sessions live only in httpOnly cookies set by the server — the browser never sees or stores a token */
  const adopt = (data) => { setUser(data); return data; };

  const login = async (email, password) => adopt((await api.post("/auth/login", { email, password })).data);
  const register = async (email, password, username) => adopt((await api.post("/auth/register", { email, password, username })).data);
  const googleSession = async (sessionId) => adopt((await api.post("/auth/google/session", { session_id: sessionId })).data);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
  };

  const rename = async (username) => { const { data } = await api.patch("/auth/me", { username }); setUser((u) => ({ ...u, ...data })); return data; };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, googleSession, logout, rename }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
